<template>
  <div>
    <mainfirst class="MainFirst d-none d-sm-block"/>
    <mbmainfirst class="mbmainfirst d-sm-none"/>
    <requestsms class="requestsms"/>
    <crazydeal class="crazydeal d-none d-sm-block"/>
    <mbcrazydeal1 class="mbcrazydeal1 d-sm-none"/>
    <mbcrazydeal2 class="mbcrazydeal2 d-sm-none"/>
    <secondcrazydealtitle />
    <secondcrazydealtimer />
    <secondcrazydealcarousel />
    <requestboard class="requestboard d-none d-sm-block"/>
    <mbrequestboard class="mbrequestboard d-sm-none"/>
    <brandList class="board"/>
    <faq class="fa d-sm-none"/>
  </div>
</template>

<script>
import { Sticky } from 'mdbvue';
import mainfirst from '@/components/MainFirst.vue';
import mbmainfirst from '@/components/mobile/MbMainFirst.vue';
import requestsms from '@/components/RequestSms.vue';
import crazydeal from '@/components/CrazyDeal.vue';
import mbcrazydeal1 from '@/components/mobile/MbCrazyDeal1.vue';
import mbcrazydeal2 from '@/components/mobile/MbCrazyDeal2.vue';
import secondcrazydealtitle from '@/components/SecondCrazyDealTitle.vue';
import secondcrazydealtimer from '@/components/SecondCrazyDealTimer.vue';
import secondcrazydealcarousel from '@/components/SecondCrazyDealCarousel.vue';
import requestboard from '@/components/RequestBoard.vue';
import mbrequestboard from '@/components/mobile/MbRequestBoard.vue';
import brandList from '@/components/BrandList.vue';
import faq from '@/views/Faq.vue';

export default {
  components: {
    mainfirst,
    mbmainfirst,
    requestsms,
    crazydeal,
    mbcrazydeal1,
    mbcrazydeal2,
    secondcrazydealtitle,
    secondcrazydealtimer,
    secondcrazydealcarousel,
    requestboard,
    mbrequestboard,
    brandList,
    faq,
  },
  directives: {
    sticky: Sticky,
  },
};
</script>

<style scoped>
.mainfirst {
  height: auto;
  max-width: 100%;
  position: relative;
}

.container-fluid {
  max-width: 100%;
  height: auto;
  padding-left: 0px;
  padding-right: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.mbmainfirst {
  height: auto;
  max-width: 100%;
  position: relative;
  padding: 0 0px;
  margin-top: 46px;
}

.crazydeal {
  max-height: 100%;
  max-width: 100%;
  position: relative;
}

.requestsms {
  max-height: 100%;
  max-width: 100%;
  position: relative;
}

.requestboard {
  height: auto;
  max-width: 100%;
  position: relative;
}

.mbrequestboard {
  max-width: 100%;
  height: auto;
  position: relative;
}

.secondcrazydeal {
  max-height: 100%;
  max-width: 100%;
  position: relative;
}

.brandlistrow {
  max-height: 100%;
  max-width: 100%;
  position: relative;
}

.middle {
  top:0px;
  left:0px;
  max-width: 100%;
  max-height: 100%;
  align-content: center;
  margin: auto auto;
  padding: 0px 0px;
}

.board{
  margin-left: auto;
  margin-right: auto;
  align-content: center;
}

.hotdeal{
  height: 100%;
}
</style>
